/**
 * First path segments under `/:organizationId` that are org pages, not app ids
 * (`/{orgId}/leads`, `/{orgId}/management`, ...). OrganizationSwitch matches these before
 * `/:organizationId/:appId`; anything reading `/:organizationId/:appId` outside that switch -- the
 * header app switcher -- must skip them too. A test fails if OrganizationSwitch gains a page
 * that is missing here.
 */
export const ORG_PAGE_ROUTES: readonly string[] = [
    "analytics",
    "apps",
    "dashboard",
    "forms",
    "iprights",
    "leads",
    "management",
    "map",
    "members",
    "settings",
];

/**
 * First path segments that are their own pages rather than an organization id: the global
 * routes in main.tsx and the top-level ones in routes/index.tsx.
 */
export const NON_ORG_ROUTES: readonly string[] = [
    "accept",
    "admin",
    "analytics",
    "apps",
    "dashboard",
    "graphql",
    "help",
    "integration",
    "leads",
    "list",
    "map",
    "onboarding",
    "organizations",
    "settings",
    "setup",
    "verify",
];

/**
 * The app id in a `/:organizationId/:appId` match, or undefined when that segment is an org page
 * or the first segment is not an organization at all. Without this the header queried
 * `app(appId: "leads")` on every org Leads page.
 */
export function appIdFromRoute(params: { organizationId?: string; appId?: string } | undefined): string | undefined {
    if (!params?.organizationId || !params.appId) {
        return undefined;
    }
    if (NON_ORG_ROUTES.includes(params.organizationId) || ORG_PAGE_ROUTES.includes(params.appId)) {
        return undefined;
    }
    return params.appId;
}
